import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import VSLogo from "@/components/VSLogo";
import { Mail, Globe, Linkedin, Instagram, Youtube } from "lucide-react";

export default function PublicFooter() {
  return (
    <footer className="bg-[#0A2540] text-slate-300 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="rounded-2xl bg-white/5 border border-white/10 p-8 md:p-12 mb-14">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="font-display text-3xl md:text-4xl font-bold text-white leading-tight">
                Ready to build what's next?
              </h3>
              <p className="mt-3 text-slate-300">Explore opportunities at VS-Solutions.</p>
            </div>
            <div className="flex flex-wrap gap-3 md:justify-end">
              <Button asChild size="lg" className="bg-[#F59E0B] text-[#0A2540] hover:bg-[#F59E0B]/90" data-testid="footer-explore-jobs">
                <Link to="/jobs">Explore Jobs</Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="border-white/40 text-white hover:bg-white/10 hover:text-white" data-testid="footer-talent-community">
                <Link to="/register">Join Our Talent Community</Link>
              </Button>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-sm">
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase text-xs tracking-wider">Company</h4>
            <ul className="space-y-2">
              <li>About VS-Solutions</li><li>Our Services</li><li>Leadership</li><li>Locations</li><li>Contact Us</li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase text-xs tracking-wider">Careers</h4>
            <ul className="space-y-2">
              <li><Link to="/jobs" className="hover:text-white">Search Jobs</Link></li>
              <li>Students & Graduates</li><li>Experienced Professionals</li>
              <li>Life at VS-Solutions</li><li>Hiring Process</li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase text-xs tracking-wider">Resources</h4>
            <ul className="space-y-2">
              <li><Link to="/login" className="hover:text-white">Candidate Login</Link></li>
              <li>Application Status</li><li>FAQs</li><li>Privacy Policy</li><li>Terms & Conditions</li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase text-xs tracking-wider">Connect</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2"><Linkedin className="w-4 h-4" /> LinkedIn</li>
              <li className="flex items-center gap-2"><Instagram className="w-4 h-4" /> Instagram</li>
              <li className="flex items-center gap-2"><Youtube className="w-4 h-4" /> YouTube</li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> info@vs-solutions.org</li>
              <li className="flex items-center gap-2"><Globe className="w-4 h-4" /> www.vs-solutions.in</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-center gap-3">
            <VSLogo size={36} dark />
            <div>
              <div className="text-white font-semibold">VS-Solutions</div>
              <div className="text-xs text-slate-400">Vijay Software Solutions Pvt. Ltd.</div>
            </div>
          </div>
          <p className="text-xs text-slate-400">© 2026 Vijay Software Solutions Pvt. Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
